/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core';
import UserMessage from './UserMessage';
// import Loading from '../../../common/Loading';
import { useAutoAnimate } from '@formkit/auto-animate/react'

const useStyles = makeStyles((theme) => ({
    firstMsg: {
        [theme.breakpoints.down('sm')]: {
            marginTop: '13rem !important',
        }
    },
    errorMsg: {
        color: 'red !important'
    },
    playbookMessage: {
        fontSize: '1.125rem !important',
        fontFamily: 'Lato, sans-serif!important',
        fontWeight: '400',
        lineHeight: '30px',
        letterSpacing: '0px',
    },
}));

const ConversationView = ({ conversations }) => {
    const classes = useStyles();
    // Added in an animation library - docs here: https://auto-animate.formkit.com/#usage
    const [parent] = useAutoAnimate();
        return conversations?.map((conversation, index) => (
            <div ref={parent} key={index} className={`${index === 0 ? classes.firstMsg : ''}`}>
                <p className={`${classes.playbookMessage} ${conversation.error ? classes.errorMsg : ''}`}>{conversation.ai}</p>
                {conversation.user && <UserMessage conversation={conversation} />}
            </div>
        ));
};

export default ConversationView;